export const EXCLUDED_INN_NAME = "Prep. złoż.";
